import { createFileRoute } from '@tanstack/react-router';
import TaxPlanningPageContainer from '../../components/portfolio-planning/TaxPlanningPageContainer';
import LoadingPage from '../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute('/_authenticated/planning')({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: TaxPlanningPageContainer,
  staticData: {
    configPageId: 'planning',
    meta: {
      title: 'Planning | Ledgible',
    },
  },
});
